import React from "react";
import { Program, programForUserType } from "../../models/program";
import { UserType } from "../../models/userType";

import AnalyticsView from "./analyticsView/analyticsView";
import SalesRepView from "./salesRepView/salesRepView";
import TrainingView from "./trainingView/trainingView";

// A client user's view IS their program. Keeping program index as the only
// axis is what let portalView and accountView collapse into one dispatch.

export type ProgramView = React.ComponentType;

/** Undefined for an unknown program, so the caller renders nothing. */
export const viewForProgram = (
  programIndex?: number,
  userTypeIndex?: number
): ProgramView | undefined => {
  switch (programIndex) {
    case Program.Index.Analytics:
      // A sales rep gets their worklist, not the client dashboard.
      return userTypeIndex === UserType.Index.SalesRep ? SalesRepView : AnalyticsView;
    case Program.Index.Training:
      return TrainingView;
    default:
      return undefined;
  }
};


export const userTypeIndexForName = (clientTypeName?: string): number | undefined =>
  clientTypeName
    ? UserType.IndexByName[clientTypeName as keyof typeof UserType.IndexByName]
    : undefined;

// Re-exported so callers of this model need not reach into models/.
export { programForUserType };
